import React, { ButtonHTMLAttributes } from "react";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  className?: string;
}

const Button: React.FC<ButtonProps> = ({
  className = "",
  children,
  ...props
}) => {
  return (
    <button
      className={`${className} text-center inline-flex items-center justify-center p-2 rounded-lg gap-2 hover:opacity-80 hover:gap-3 text-light font-semibold bg-sky-blue hover:bg-sky-blue min-w-[100px]`}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;
